<template>
  <modal @close="$emit('close')">
    <h4 slot="header">Configurar cabeceras visibles</h4>

    <template v-slot.body>
      <md-table
        v-model="filteredTableHeaders"
        md-card
        :md-selected-value="visibleTableHeaders"
        @md-selected="visibleTableHeaders = $event"
        md-fixed-header
      >
        <md-table-toolbar>
          <md-field>
            <md-input v-model="tabFilter" placeholder="Filtrar campos" />
          </md-field>
        </md-table-toolbar>
        <md-table-row
          slot="md-table-row"
          slot-scope="{ item: [key, label] }"
          md-selectable="multiple"
        >
          <md-table-cell md-label="Campo">{{ label }}</md-table-cell>
        </md-table-row>
      </md-table>
    </template>

    <div class="md-group" slot="footer">
      <md-button class="md-success md-simple" @click="save">Aceptar</md-button>
      <md-button class="md-danger md-simple" @click="$emit('close')">Cancelar</md-button>
    </div>
  </modal>
</template>

<script>
import { Modal } from "@/components";

export default {
  name: "VisibleHeadersModal",

  props: {
    headers: {
      type: Object,
      required: true,
    },
    value: {
      type: Array,
      required: false,
    },
  },

  computed: {
    tableHeaders() {
      return Object.entries(this.headers);
    },
    visibleTableHeaders: {
      get() {
        const { tableHeaders, internalValue } = this;
        const visHeaders =
          internalValue && !!internalValue.length
            ? internalValue
            : Object.keys(tableHeaders);

        return tableHeaders.filter(([k]) => internalValue.includes(k));
      },
      set(value = []) {
        this.internalValue = value.map(([k]) => k);
      },
    },
    filteredTableHeaders() {
      const { tabFilter, tableHeaders } = this;

      if (tabFilter && tabFilter !== "") {
        return tableHeaders.filter(([k, h]) => h.includes(tabFilter));
      } else {
        return tableHeaders;
      }
    },
  },

  data() {
    return {
      localVisibleHeaders: [],
      selected: [],
      newVisible: {},
      tabFilter: "",
      internalValue: [],
    };
  },

  methods: {
    save() {
      this.$emit("input", this.internalValue);
      this.$emit("close");
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(visible = []) {
        this.internalValue = [...visible];
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Tables/VisibleHeadersModal.vue